import type { TableRow } from "@prequel/shared-components";

import type { ProviderFilters } from "@/api/import/providers";
import type { ProviderResource } from "@/api/import/providers";
import { useListProviders } from "@/api/import/providers";
import type { PageOptions } from "@/api/pagination";
import ResourceTable, { type FilterField } from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";
import { useDatalakeContext } from "@/pages/import/DatalakesPage/DatalakePage";

const COLUMNS = ["Name", "Provider ID", "Created"];

const FILTER_FIELDS: FilterField[] = [
  {
    key: "is_enabled",
    label: "Status",
    queryParam: "is_enabled",
    radio: true,
    options: [
      { value: "true", label: "Enabled" },
      { value: "false", label: "Disabled" },
    ],
  },
];

const DatalakeProviders = () => {
  const { datalake } = useDatalakeContext();

  const useQuery = (options: PageOptions, filters?: ProviderFilters) =>
    useListProviders(options, { ...filters, datalake_id: datalake.id });

  const mapProviderToRow = (provider: ProviderResource): TableRow => ({
    id: provider.id,
    to: `/import/providers/${provider.id}`,
    cells: [
      { value: provider.name },
      // Provider IDs are customer-assigned rather than generated, so they read as names.
      { value: <span className="font-mono text-xs">{provider.id}</span> },
      { value: <Timestamp timestamp={provider.created_at} /> },
    ],
  });

  return (
    <ResourceTable<ProviderResource>
      columns={COLUMNS}
      useQuery={useQuery}
      rowMapper={mapProviderToRow}
      emptyMessage="No providers are using this datalake yet."
      filterFields={FILTER_FIELDS}
    />
  );
};

export default DatalakeProviders;
